<ion-header
  class="order-options_header ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-label data-cy="select-order-number-label">
      {{ 'i18n.requestCredit.selectOrderNumber' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="
    (serviceRequestService?.orders$ | async)?.ordersLoaded as loaded;
    else spinner
  "
  class="order-options_content"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <ng-container
    *ngIf="(serviceRequestService?.orders$ | async)?.myOrders as orders"
  >
    <div class="searchbar-section" slot="fixed">
      <ion-searchbar
        id="order-number-selection-searchbar"
        data-cy="order-number-selection-searchbar"
        class="search"
        mode="md"
        placeholder="{{
          'i18n.requestCredit.searchYourEligibleOrders' | translate
        }}"
        (ionInput)="filterOrderNumbers($event)"
        (ionClear)="clearOrderNumbersFilter()"
        [debounce]="serviceRequestService?.debounceTime"
      ></ion-searchbar>
    </div>
    <div *ngIf="!orders?.length && loaded" class="no-data-found">
      <p data-cy="no-order-numbers-found-text">
        {{ 'i18n.requestCredit.noOrderNumbersFound' | translate }}
      </p>
    </div>
    <ion-list *ngIf="orders?.length" class="orders-list">
      <ion-item-divider></ion-item-divider>
      <ion-item
        *ngFor="let order of orders; let i = index"
        id="order-number-{{ i }}"
        detail="true"
        (click)="getProductsByOrder(order)"
        [class.selected]="
          serviceRequestService?.modalRelatedParams?.order === order
        "
        data-cy="click-get-products-and-order-number"
      >
        <ion-label>
          <p
            class="info-top"
            [attr.data-cy]="
              'order-number-' + order?.orderHeader?.tandemOrderNumber + '-text'
            "
          >
            <!-- Order Number -->
            {{ 'i18n.requestCredit.order' | translate }}&nbsp;
            {{ order?.orderHeader?.tandemOrderNumber || '-' }}&nbsp;
            <!-- Delivery Method -->
            ({{ getOrderTypeLabel(order) | translate }})
          </p>
          <p class="order-info-bottom">
            <!-- Order Placed -->
            <span
              [attr.data-cy]="
                'order-placed-date-' +
                order?.orderHeader?.tandemOrderNumber +
                '-text'
              "
            >
              {{ 'i18n.requestCredit.orderPlaced' | translate }}&nbsp;
              {{ order?.orderHeader?.orderDate | date: 'M/d/yy':'GMT' }}
            </span>
            <span>|</span>
            <!-- Delivered -->
            <span
              [attr.data-cy]="
                'order-confirmed-delivery-date-' +
                order?.orderHeader?.tandemOrderNumber +
                '-text'
              "
            >
              {{ 'i18n.requestCredit.delivered' | translate }}&nbsp;
              {{
                order?.orderHeader?.confirmedDeliveryDate | date: 'M/d/yy':'GMT'
              }}
            </span>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-select-order-modal-button"
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.tablet
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismissModal(true)"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<!--Spinner Template-->
<ng-template #spinner>
  <div class="spinner-container">
    <ion-label>
      {{ 'i18n.requestCredit.loadingOrders' | translate }}
    </ion-label>
    <ion-spinner
      name="circles"
      class="order-spinner"
      data-cy="loading-spinner"
    ></ion-spinner>
  </div>
</ng-template>
